import {StyleSheet} from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  section: {
    fontWeight: 'bold',
    marginTop: 15,
  },
  sousSection: {
    paddingRight: 60,
    paddingLeft: 60,
    paddingTop: 20,
    fontSize: 10,
    fontFamily: 'Arial',
  },
  title: {
    fontSize: 14,
    textAlign: 'center',
    fontWeight: 'semibold',
    textTransform: 'uppercase',
    fontFamily: 'Arial',
  },
  subtitle1: {
    fontWeight: 'semibold',
    fontFamily: 'Arial',
    textDecoration: 'underline',
    fontSize: 12,
    margin: 2,
  },
  subtitle2: {
    fontWeight: 'semibold',
    fontFamily: 'Arial',
    textDecoration: 'underline',
    fontSize: 11,
    margin: 2,
  },
  subtitle3: {
    fontFamily: 'Arial',
    textDecoration: 'underline',
    fontSize: 11,
    margin: 2,
  },
  textBolded: {
    fontFamily: 'Arial',
    fontWeight: 'bold',
    fontSize: 10,
    margin: 2,
  },
  text: {
    fontFamily: 'Arial',
    fontSize: 10,
    margin: 2,
  },
  page: {
    position: 'relative',
    flexDirection: 'column',
  },
  backgroundContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  contentContainer: {
    position: 'relative',
    marginLeft: 50,
    marginTop: 70,
  },
});
